module.exports = __webpack_public_path__ + "img/typeBar_bg.08955f90.png";